import { DiaryEvent } from "../models/diary-event"
import * as diaryActions from "../actions/diary-actions"

import { createEntityAdapter } from "@ngrx/entity"
import { EntityState } from "@ngrx/entity"

/**
 * An entity list will be used to store data for individual diary widget instances
 */
export class DiaryWidgetInstance {
  id: string;             // widget instance id
  events: DiaryEvent[];   // diary event data
  loading: boolean;
  error: string;
  searchText: string;
}

export const diaryWidgetAdapter = createEntityAdapter<DiaryWidgetInstance>();

export interface DiaryWidgetDataState extends EntityState<DiaryWidgetInstance> {};

export const INITIAL_STATE: DiaryWidgetDataState = diaryWidgetAdapter.getInitialState();

export function reducer(state: DiaryWidgetDataState = INITIAL_STATE, action: diaryActions.Actions): DiaryWidgetDataState {
  switch (action.type) {

    case diaryActions.FILTER:
    {
      if ((<Array<string>>state.ids).indexOf(action.widgetId) !== -1) {
        return diaryWidgetAdapter.updateOne({ id: action.widgetId.toString(), changes: { searchText: action.searchText } }, state);
      }

      return diaryWidgetAdapter.addOne({ id: action.widgetId.toString(), searchText: action.searchText, events: [], error: null, loading: false }, state);

    }
    case diaryActions.LOAD:
      {
        // @todo: need to clean this up
        //  https://github.com/ngrx/platform/issues/595
        if ((<Array<string>>state.ids).indexOf(action.widgetId.toString()) !== -1) {
          return diaryWidgetAdapter.updateOne({ id: action.widgetId.toString(), changes: { loading: true } }, state);
        }

        return diaryWidgetAdapter.addOne({ id: action.widgetId.toString(), loading: true, events: [], error: null, searchText: null }, state);

    }
    case diaryActions.LOAD_COMPLETE:
      {
        // @todo: need to clean this up
        //  https://github.com/ngrx/platform/issues/595
        if ((<Array<string>>state.ids).indexOf(action.widgetId) !== -1 ) {
          return diaryWidgetAdapter.updateOne({ id: action.widgetId.toString(), changes: { id: action.widgetId.toString(), events: action.payload, loading: false }}, state);
        }
        return diaryWidgetAdapter.addOne({ id: action.widgetId.toString(), events: action.payload, loading: false, error: null, searchText: null }, state );
    }
    case diaryActions.LOAD_ERROR:
    {
      let errorMessage = null;
      if (action.payload.hasOwnProperty('message')) {
        errorMessage = action.payload.message;
      }
      if (typeof state.ids[action.widgetId] === 'undefined') {
        return diaryWidgetAdapter.updateOne({ id: action.widgetId.toString(), changes: { error: errorMessage } }, state);
      }
      return state;
    }
    case diaryActions.LOAD_UNDATED_EVENTS:
    {
      return diaryWidgetAdapter.upsertOne({id: action.widgetId.toString(), loading: true, events: [], error: null, searchText: null}, state);
    }
    default:
    {
      return state;
    }
  }
}
